import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Box,
  Typography,
  Container,
} from "@material-ui/core";

import Loader from "../../components/Loader";
import { LOGIN_API } from "../../configs/urls";

import { postApi } from "../../services/api";
import { saveUserCredentials } from "../../services/localstorage";
import { useHistory } from "react-router-dom";

import useForm from "../../formValidator/userForm";

import logo from "assets/img/logo.jpeg";

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Username is required.";
  }

  if (!values.password) {
    errors.password = "Password is required";
  }

  return errors;
};

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(20),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  logo: {
    width: 350,
    marginBottom: 50,
  },
}));

export default function Login() {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);

  const loginUser = () => {
    setIsRequestig(true);
    postApi(LOGIN_API, params)
      .then(
        (res) => {
          saveUserCredentials(res.data, res.token);
          history.replace("/admin/dashboard");
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const { params, errors, handleChange, handleSubmit } = useForm(
    loginUser,
    validate
  );

  const history = useHistory();

  useEffect(() => {
    manageRedirection();
    return function () {
      /**
       * Add cleanup code here
       */
      // setIsRequestig(false);
    };
  });

  const manageRedirection = () => {
    if (localStorage.user) {
      history.replace("/admin/dashboard");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Loader isLoading={isRequesting} />
      <CssBaseline />
      <div className={classes.paper}>
        <img src={logo} className={classes.logo}></img>
        {/* <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar> */}

        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Username"
            name="email"
            autoComplete="email"
            autoFocus
            value={params.email || ""}
            onChange={handleChange}
          />
          {errors.email && <Box color="secondary.main">{errors.email}</Box>}
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={params.password || ""}
            onChange={handleChange}
          />
          {errors.password && (
            <Box color="secondary.main">{errors.password}</Box>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Log In
          </Button>
        </form>
      </div>
    </Container>
  );
}
